import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
const highlights = ['Teoria + 50 ćwiczeń jazzowych', '6 kompletnych tomów', '6 darmowych bonusów', 'Pełna część teoretyczna', '100% PDF · Drukuj i ucz'];
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];
export function Hero() {
  return <header id="top" className="bg-night" data-id="element-190" data-mp="x8jojrugd0ju">
      <div className="mx-auto max-w-shell px-5 pb-12 pt-12 sm:px-6 sm:pb-16 sm:pt-16" data-id="element-191" data-mp="sa9rfbp63pvl">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-4xl text-center" data-id="element-192" data-mp="nczs94bz7zuk">
          <Eyebrow align="center" data-id="element-193" data-mp="380vznzu8sxe7">Kompletna metoda dla nauczycieli gitary jazzowej</Eyebrow>
          <h1 className="mt-6 font-display text-[2.6rem] leading-[0.95] sm:text-7xl lg:text-8xl" data-id="element-194" data-mp="3j9tymsm91cin">
            <span className="block text-cream" data-id="element-195" data-mp="3o6alzklmjmuo">Zorganizuj cały swój</span>
            <span className="block text-amber" data-id="element-196" data-mp="39b4ib4a0404i">semestr jazzu z tym pakietem</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl font-serif text-lg italic leading-relaxed text-cream-soft sm:text-2xl" data-id="element-197" data-mp="3e8mtl1bhqrfo">
            System &bdquo;Drukuj i ucz&rdquo; dla nauczycieli gitary jazzowej, który zmienia
            planowanie lekcji z <span className="text-amber" data-id="element-198" data-mp="35aasg5d00b8z">chaotycznego</span> w{' '}
            <span className="text-cream" data-id="element-199" data-mp="2qkmsp8kgtknd">oczywiste</span>.
          </p>
        </motion.div>
        <div className="relative mx-auto mt-10 max-w-5xl sm:mt-12" data-id="element-200" data-mp="2viewp0ydwx7x">
          <span className="absolute -top-3.5 right-4 z-10 rounded-full bg-amber px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-night sm:-top-4 sm:right-6 sm:px-4 sm:text-xs" data-id="element-201" data-mp="2vglkz78wzmt2">
            6 tomów + 6 bonusów
          </span>
          <div className="rounded-2xl border border-night-600 bg-night-800 p-2 sm:p-3" data-id="element-202" data-mp="s335feo1gqy2">
            <img src="https://cdn.magicpatterns.com/uploads/vL3a7ZezmJRFuApQTcxmoi/Imagen_de_ChatGPT_30_sept_2026,_12_18_55_p.m..png" alt="Kompletny Arsenał Nauczyciela Jazzu: sześć podręczników oraz kurs na komputerze, tablecie i telefonie" className="w-full rounded-xl" data-id="element-203" data-mp="nb1kz5gpvtwy" />
          </div>
        </div>
        <ul className="mx-auto mt-10 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-2 sm:gap-x-7" data-id="element-204" data-mp="1ayt68yk8jhad">
          {highlights.map(item => <li key={item} className="text-[10px] font-semibold uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-205" data-mp="111yb8pn67z0u">
              {item}
            </li>)}
        </ul>
        <div className="mt-8 flex flex-col items-center gap-3" data-id="element-206" data-mp="3luiaiu6w15my">
          <CtaButton size="lg" target="offer" data-id="element-207" data-mp="3hqtz20f4xpwf">
            Zdobądź Arsenał teraz
          </CtaButton>
          <p className="text-center text-xs text-amber-light" data-id="element-208" data-mp="1xa429a5swchi">
            $35 dzisiaj &mdash; po upływie czasu cena wraca do $97.
          </p>
          <div className="mt-2 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-209" data-mp="21b66y6ihlgqv">
            {assurances.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-2 text-xs text-cream-muted" data-id="element-210" data-mp="2b0fz1mdbyzez">
                <Icon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-211" data-mp="2g02jafrktfxa" />
                {label}
              </span>)}
          </div>
        </div>
      </div>
    </header>;
}